'use client'
import { useTranslations } from 'next-intl'
import { Suspense, useCallback, useState } from 'react'
import './globalSearch.scss'
import { ConnectingDots } from '../icons'
import dynamic from 'next/dynamic'
import FormLoading from './FormLoading'
import Script from 'next/script'

const BTHForm = dynamic(() => import('./BTHForm'), { ssr: false ,   loading: () => <FormLoading />})
const TransferForm = dynamic(() => import('./TransferForm'), { ssr: false ,   loading: () => <FormLoading />
})

const GlobalSearch = () => {
  const [activeTab, setActiveTab] = useState('transfer')
  const t = useTranslations('globalSearch')
  
  const handleTabChange = useCallback((tab) => () => setActiveTab(tab), [])

  return (
    <div className='global-search min-h-[500px]' id='globalSearch'>
      <div className='tabs-container'>
        <button
          className={`tab ${activeTab === 'transfer' ? 'active' : ''}`}
          onClick={handleTabChange('transfer')}
          type='button'
        >
          {t('tabs.transfer')}
        </button>
        <button
          className={`tab ${activeTab === 'BTH' ? 'active' : ''}`}
          onClick={handleTabChange('BTH')}
          type='button'
        >
          {t('tabs.BTH')}
        </button>
      </div>
      <Suspense fallback={<FormLoading/>}>
      {activeTab === 'transfer' ? <TransferForm /> : <BTHForm />}
      </Suspense>
      <div className='connectingdots'>
        <ConnectingDots />
      </div>
    </div>
  )
}

export default GlobalSearch